import { motion } from "framer-motion";
import { ArrowDown, MapPin } from "lucide-react";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/bef13f1daac35a77b0153bac43c927e36792ce732857819bd0c65d07f4fbcaf3.png";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-end overflow-hidden bg-bone pt-28"
    >
      {/* Image background */}
      <div className="absolute inset-0">
        <motion.img
          src={HERO_IMG}
          alt="Appartement haussmannien rénové à Paris par MAISON FAUBOURG"
          className="w-full h-full object-cover"
          initial={{ scale: 1.15 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2.4, ease: [0.2, 0.7, 0.2, 1] }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-bone/40 via-transparent to-bone" />
      </div>

      {/* Top overline */}
      <div className="relative container-max pt-6 flex items-center justify-between text-ink">
        <motion.span
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="overline flex items-center gap-2"
        >
          <MapPin className="w-3 h-3" /> Paris · Île-de-France · Depuis 2014
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 1 }}
          className="overline hidden md:inline"
        >
          Édition n° 12 — Hiver 2026
        </motion.span>
      </div>

      {/* Content */}
      <div className="relative container-max pb-16 md:pb-24">
        <div className="grid grid-cols-12 items-end gap-8">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, delay: 0.2, ease: [0.2, 0.7, 0.2, 1] }}
            className="col-span-12 md:col-span-9 font-display font-light text-[14vw] md:text-[9.5vw] leading-[0.88] tracking-tighter text-ink"
          >
            Rénover<br />
            comme l'on<br />
            <em className="italic text-terracotta font-normal">compose</em> une œuvre.
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.9 }}
            className="col-span-12 md:col-span-3 md:pl-8 md:border-l md:border-ink/30 self-end"
          >
            <p className="text-ink/80 leading-relaxed text-base md:text-lg">
              Atelier parisien de rénovation d'appartement. Maîtrise d'œuvre, artisans signature, conception architecturale —&nbsp;<em>de la dépose au mobilier sur-mesure</em>.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a data-testid="hero-cta-quote" href="#devis" className="btn-sharp">Demander un devis</a>
              <a data-testid="hero-cta-projects" href="#projets" className="btn-ghost">Voir nos projets</a>
            </div>
          </motion.div>
        </div>

        {/* Bottom strip */}
        <div className="mt-12 pt-6 border-t border-ink/20 flex flex-wrap items-center justify-between gap-6 text-ink">
          <div className="flex items-center gap-10">
            <div>
              <p className="overline">Projets livrés</p>
              <p className="font-display text-3xl mt-1">187</p>
            </div>
            <div>
              <p className="overline">Note clients</p>
              <p className="font-display text-3xl mt-1">4,9<span className="text-ink/40 text-xl">/5</span></p>
            </div>
            <div className="hidden md:block">
              <p className="overline">Décennale</p>
              <p className="font-display text-3xl mt-1">Garantie</p>
            </div>
          </div>
          <a href="#manifeste" className="overline flex items-center gap-2 link-arc">
            Lire la suite <ArrowDown className="w-3 h-3" />
          </a>
        </div>
      </div>
    </section>
  );
}
